import { ConditionalWrapper } from '~/components/ConditionalWrapper/ConditionalWrapper';
import { PropsWithChildren } from 'react';
import styles from './Table.module.css';
import classNames from 'classnames';

type Props = PropsWithChildren & {
  label: string;
  inline?: boolean;
};

export function FilterSection({ children, label, inline = false }: Props) {
  return (
    <div
      className={classNames(styles.section, {
        [styles.inline]: inline,
      })}
    >
      <h6 className={styles.title}>{label}</h6>
      <ConditionalWrapper condition={inline} wrap={c => <div className={styles.inline}>{c}</div>}>
        {children}
      </ConditionalWrapper>
    </div>
  );
}
